export class RestoreGoogleWorkspaceUserRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<GoogleWorkspaceUserRestoreWorkload>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceUserRequest.attributeTypeMap;
    }
    constructor() {
    }
}
